<template>
    <CoverPanel
        class="image-cover"
        :noCoverIcon="noCoverIcon"
        :imageUrl="imageUrl"
        :operateIcons="editConfig.operateIcons"
        :viewIcon="editConfig.viewIcon"
        ishorizontal="true"
        @uploadCover="uploadCover"
        @operatorSelect="operatorSelect"
    />
</template>

<script>
import ImageClipModal from "@/views/zhiji/components/imageUpload/ImageClipModal";
import CoverPanel from "@/views/zhiji/components/coverPanel/CoverPanel";
import { videoEditConfig } from "@/views/zhiji/components/materialLibrary/materialLibraryConfig.js";

export default {
    name: "ImageCover",
    props: ["value", "aspectRatio", "needClip"],
    components: {
        CoverPanel
    },
    data() {
        return {
            editConfig: videoEditConfig(),
            imageUrl: this.value
        };
    },
    computed: {
        noCoverIcon() {
            return {
                position: "-56px 0",
                label: this.$t("zhiji.answer.addPicture")
            };
        }
    },
    watch: {
        value() {
            this.imageUrl = this.value;
        }
    },
    methods: {
        uploadCover() {
            this.uploadImage(imageUrl => {
                this.imageUrl = imageUrl;
                this.$emit("input", imageUrl);
            });
        },
        operatorSelect(type) {
            if (type == "update") {
                this.uploadCover();
            }
        },
        uploadImage(cb) {
            this.$store.commit("zhiji/showModal", {
                type: ImageClipModal,
                data: {
                    openFile: openFile => {
                        this.openFile = openFile;
                    },
                    confirm: url => {
                        cb && cb(url);
                    },
                    cancel: () => {
                        this.openFile = null;
                    },
                    needClip: this.needClip != null ? this.needClip : true,
                    aspectRatio: this.aspectRatio
                }
            });

            // 打开组件时弹出文件选择，只有在isTrusted事件里面可以触发, HACK
            setTimeout(() => {
                this.openFile();
                this.openFile = null;
            }, 300);
        }
    }
};
</script>

<style scope>
.image-cover {
    width: 142px;
    height: 107px !important;
    border: 1px solid #d8e4f0;
}
</style>
